export const VenueType = [
  "Banquets",
  "Party Halls",
  "Convention Centre",
  "Farm Houses",
  "Roof Tops",
  "Auditoriums",
  "Yacht",
  "Palace",
  "Sports Complex",
  "Open air places",
];
export const VenueFacilities = [
  "Digital Projector",
  "Projector Screen",
  "Wifi",
  "Audio - Mic & System",
  "Video - conf system",
  "Fully Air Conditioned",
  "Copier Facility",
  "Printer",
  "Free Parking",
  "Tea-Coffee Station",
  "Smoking zone",
  "Currency Exchange",
  "Airport Drop Service",
  "DJ Service",
];
export const VenueServices = [
  "Event Management",
  "Logistics",
  "Photography",
  "Video graphy",
  "Party Supplies",
  "RSVP Management",
  "Event Staff",
  "Digital Marketing",
  "Catering Service",
  "Equipment Supplier",
  "Survey",
  "Flowers & Decor",
  "Gift Souveniers",
  "Birthday Sepcialist",
];
